const saveDept = (state,deptInfo)=>{
  // 当进行push操作的时候直接push到state声明的数组中
  state.totalDeptList.push(deptInfo)
}

const saveCardInfo = (state,cardInfo)=>{
  state.cardInfo = cardInfo
}

const saveCashOut = (state,cashoutInfo)=>{
  state.cashoutInfo = cashoutInfo
}
export default{
  saveDept,
  saveCardInfo,
  saveCashOut
}


// WEBPACK FOOTER //
// ./src/store/mutations.js